(() => {
  'use strict';
  let serial = 0;
  function enhance(root) {
    if (root.dataset.premiumFinder || !window.HTMLDialogElement) return;
    const form = root.querySelector('.finder-form, .home-finder');
    const selects = ['brand', 'model'].map(key => root.querySelector(`[data-${key}]`));
    if (!form || form.hidden || selects.some(select => !select) || selects[0].options.length < 2) return;
    root.dataset.premiumFinder = 'true';
    let logos = {};
    try { logos = JSON.parse(root.querySelector('[data-brand-logos]')?.textContent || '{}'); } catch { /* Brand names work without an image. */ }
    function brandLogo(brand) {
      if (!logos[brand]) return null;
      const image = document.createElement('img'); image.className = 'finder-brand-logo';
      image.src = logos[brand]; image.alt = ''; image.width = 52; image.height = 36; image.decoding = 'async';
      image.addEventListener('error', () => image.remove(), { once: true });
      return image;
    }
    const uid = `premium-finder-${++serial}`;
    const dialog = document.createElement('dialog');
    dialog.className = 'finder-dialog';
    dialog.id = uid;
    dialog.setAttribute('aria-labelledby', `${uid}-title`);
    const head = document.createElement('div'); head.className = 'finder-dialog-head';
    const title = document.createElement('h2'); title.id = `${uid}-title`; title.tabIndex = -1;
    // A non-editable initial focus never opens the phone keyboard via showModal().
    title.setAttribute('autofocus', '');
    const close = document.createElement('button'); close.type = 'button'; close.className = 'finder-dialog-close'; close.textContent = '×'; close.setAttribute('aria-label', root.dataset.dialogClose);
    head.append(title, close);
    const label = document.createElement('label'); label.htmlFor = `${uid}-search`; label.className = 'sr-only'; label.textContent = root.dataset.dialogFilter;
    const searchField = document.createElement('div'); searchField.className = 'finder-dialog-search-field';
    const searchIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); searchIcon.setAttribute('viewBox', '0 0 24 24'); searchIcon.setAttribute('aria-hidden', 'true');
    const searchPath = document.createElementNS('http://www.w3.org/2000/svg', 'path'); searchPath.setAttribute('d', 'M21 21l-4.5-4.5M19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0'); searchIcon.append(searchPath);
    const search = document.createElement('input'); search.type = 'search'; search.id = `${uid}-search`; search.autocomplete = 'off'; search.className = 'finder-dialog-search';
    search.spellcheck = false;
    const clear = document.createElement('button'); clear.type = 'button'; clear.className = 'finder-search-clear'; clear.textContent = '×'; clear.setAttribute('aria-label', root.dataset.dialogClear); clear.hidden = true;
    searchField.append(label, searchIcon, search, clear);
    const status = document.createElement('p'); status.className = 'finder-dialog-status'; status.setAttribute('role', 'status');
    const list = document.createElement('div'); list.className = 'finder-dialog-list';
    const steps = document.createElement('nav'); steps.className = 'finder-dialog-steps'; steps.setAttribute('aria-label', root.dataset.dialogSteps);
    dialog.append(head, steps, searchField, status, list);
    root.append(dialog);
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[^a-z0-9]/g, '');
    let current = 0, opener = null;
    const touchLayout = matchMedia('(max-width: 800px), (pointer: coarse)');
    const viewport = window.visualViewport;
    const fitViewport = () => {
      dialog.style.setProperty('--finder-viewport-height', `${viewport?.height || innerHeight}px`);
      dialog.style.setProperty('--finder-viewport-top', `${viewport?.offsetTop || 0}px`);
    };
    const buttons = selects.map((select, index) => {
      const button = document.createElement('button'); button.type = 'button'; button.className = 'finder-choice';
      button.setAttribute('aria-haspopup', 'dialog'); button.setAttribute('aria-controls', uid); button.setAttribute('aria-expanded', 'false');
      const label = document.createElement('span'); label.className = 'finder-choice-label';
      const value = document.createElement('span'); value.className = 'finder-choice-value';
      button.append(label, value); select.insertAdjacentElement('afterend', button);
      button.addEventListener('click', () => { opener = button; open(index); });
      return button;
    });
    function sync() {
      selects.forEach((select, index) => {
        const button = buttons[index];
        button.disabled = select.disabled;
        button.querySelector('.finder-choice-label').textContent = `${index + 1}. ${select.labels?.[0]?.textContent || [root.dataset.dialogBrand, root.dataset.dialogModel][index]}`;
        const value = button.querySelector('.finder-choice-value');
        const text = document.createElement('span'); text.textContent = select.selectedOptions[0]?.textContent || select.options[0]?.textContent || '';
        const logo = index === 0 && select.value ? brandLogo(select.value) : null;
        value.replaceChildren(...[logo, text].filter(Boolean));
        button.classList.toggle('has-selection', Boolean(select.value));
      });
    }
    function render() {
      const select = selects[current];
      const terms = search.value.trim().split(/\s+/).map(normalize).filter(Boolean);
      const options = [...select.options].filter(option => option.value && !option.disabled && terms.every(term => normalize(option.textContent).includes(term)));
      clear.hidden = !search.value;
      status.textContent = root.dataset.dialogChoices.replace('{{ count }}', options.length);
      list.replaceChildren();
      for (const option of options) {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'finder-dialog-option';
        const body = document.createElement('span'); body.className = 'finder-option-body';
        const parts = option.textContent.split(' · ');
        const name = document.createElement('span'); name.className = 'finder-option-name'; name.textContent = parts.shift();
        const detail = document.createElement('span'); detail.className = 'finder-option-detail'; detail.textContent = parts.join(' · ');
        body.append(name); if (detail.textContent) body.append(detail);
        const logo = current === 0 ? brandLogo(option.value) : null;
        if (logo) button.append(logo);
        const check = document.createElement('span'); check.className = 'finder-option-check'; check.textContent = '✓'; check.setAttribute('aria-hidden', 'true');
        button.append(body, check); button.setAttribute('aria-pressed', String(select.value === option.value));
        button.addEventListener('click', () => {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          sync();
          if (current < selects.length - 1 && !selects[current + 1].disabled) open(current + 1);
          else { dialog.close(); form.querySelector('[type="submit"]')?.focus(); }
        });
        list.append(button);
      }
      if (!options.length) {
        const empty = document.createElement('p'); empty.className = 'finder-dialog-empty'; empty.textContent = root.dataset.dialogEmpty; list.append(empty);
      }
    }
    function open(index) {
      current = index; search.value = '';
      buttons.forEach((button, i) => button.setAttribute('aria-expanded', String(i === index)));
      steps.replaceChildren();
      [root.dataset.dialogBrand, root.dataset.dialogModel].forEach((name, i) => {
        const step = document.createElement('button'); step.type = 'button'; step.textContent = `${i + 1}. ${name}`; step.disabled = selects[i].disabled;
        if (i === index) step.setAttribute('aria-current', 'step');
        step.addEventListener('click', () => open(i)); steps.append(step);
      });
      title.textContent = index === 0 ? root.dataset.dialogYourBrand : root.dataset.dialogYourModel.replace('{{ brand }}', selects[0].value);
      search.placeholder = index === 1 ? root.dataset.dialogSearchModel : root.dataset.dialogSearchBrand;
      render();
      if (!dialog.open) {
        fitViewport();
        viewport?.addEventListener('resize', fitViewport);
        viewport?.addEventListener('scroll', fitViewport);
        dialog.showModal();
      }
      (touchLayout.matches ? title : search).focus({ preventScroll: true });
      list.scrollTop = 0;
      dialog.scrollTop = 0;
    }
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      viewport?.removeEventListener('resize', fitViewport);
      viewport?.removeEventListener('scroll', fitViewport);
      buttons.forEach(button => button.setAttribute('aria-expanded', 'false'));
      if (document.activeElement === document.body || dialog.contains(document.activeElement)) opener?.focus({ preventScroll: true });
    });
    // A pointer click outside the actual panel closes it; clicks on panel padding do not.
    let pointerBeganOutside = false;
    const outside = event => { const rect = dialog.getBoundingClientRect(); return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom; };
    dialog.addEventListener('pointerdown', event => { pointerBeganOutside = event.target === dialog && outside(event); });
    dialog.addEventListener('click', event => { if (pointerBeganOutside && event.target === dialog && outside(event)) dialog.close(); pointerBeganOutside = false; });
    search.addEventListener('input', () => { render(); list.scrollTop = 0; });
    clear.addEventListener('click', () => { search.value = ''; render(); search.focus(); });
    search.addEventListener('keydown', event => { if (event.key === 'ArrowDown') { event.preventDefault(); list.querySelector('button')?.focus(); } });
    list.addEventListener('keydown', event => {
      const options = [...list.querySelectorAll('button')]; const index = options.indexOf(document.activeElement); let target;
      if (event.key === 'ArrowDown') target = options[Math.min(index + 1, options.length - 1)];
      if (event.key === 'ArrowUp') target = index <= 0 ? search : options[index - 1];
      if (event.key === 'Home') target = options[0]; if (event.key === 'End') target = options.at(-1);
      if (target) { event.preventDefault(); target.focus(); }
    });
    selects.forEach(select => {
      select.addEventListener('change', sync);
      // Keep required native selects in the form and forward invalid focus to the visible control.
      select.addEventListener('invalid', event => { event.preventDefault(); if (!dialog.open) { opener = buttons[selects.indexOf(select)]; open(selects.indexOf(select)); } });
      select.classList.add('finder-native-select'); select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');
      select.labels?.forEach(label => label.classList.add('finder-native-label'));
    });
    sync();
    root.classList.add('finder-enhanced');
  }
  function init(scope = document) { scope.querySelectorAll('vehicle-finder, home-vehicle-finder').forEach(enhance); }
  document.addEventListener('mst:finder-ready', event => enhance(event.target));
  init();
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
